import { updateFinding } from '@process-advisor/process-miner/processMiner/processMiner';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    finding?: any,
}

export async function  processFindingDataGrid ({
    finding, 
    eventEmitter,
}: Props) {
    await updateFinding({
        findingID: finding.findingID,
        finding: finding.finding,
        id: finding.id,
        mode: 'edit',
        category: finding.category,
        type: finding.type,
        finding_type: finding.finding_type,
        finding_detail: finding.finding_detail,
        source: finding.source,
        tasks: finding.tasks,
        events: finding.events,
        calculate_cost_impact: finding.calculate_cost_impact, 
        automation_opportunity: finding.automation_opportunity,
        filters: finding.filters,
    },'','processFinding')
    apiProvider.processFindingUpdateDiagram({})
    eventEmitter.emit(Event.setActionBar_Visualizer)
    
};

